import { createAction } from '@reduxjs/toolkit';
import { ItemRequestPayload } from '../queryResults/models';
import { IItemResponse, ItemDetailActionTypes, PerformanceDataResponse } from './models';

export const loadItemDetailStart = createAction(
  ItemDetailActionTypes.LOAD_ITEM_START,
  (payload: ItemRequestPayload) => ({payload})
);

export const loadItemResponseSuccess = createAction(
  ItemDetailActionTypes.LOAD_ITEM_RESPONSE_SUCCESS,
  (payload: IItemResponse) => ({payload})
);

export const loadItemResponseFailure = createAction(
  ItemDetailActionTypes.LOAD_ITEM_RESPONSE_FAILURE,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (payload: any) => ({payload})
);

export const loadItemScoreGuideSuccess = createAction(
  ItemDetailActionTypes.LOAD_SCORE_GUIDE_SUCCESS,
  (payload: string) => ({payload})
);

export const loadItemScoreGuideFailure = createAction(
  ItemDetailActionTypes.LOAD_SCORE_GUIDE_FAILURE,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (payload: any) => ({payload})
);

export const loadItemSampleResponsesSuccess = createAction(
  ItemDetailActionTypes.LOAD_SAMPLE_RESPONSES_SUCCESS,
  (payload: string) => ({payload})
);

export const loadItemSampleResponsesFailure = createAction(
  ItemDetailActionTypes.LOAD_SAMPLE_RESPONSES_FAILURE,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (payload: any) => ({payload})
);

export const loadItemPerformanceDataStart = createAction(
  ItemDetailActionTypes.LOAD_PERFORMANCE_DATA_START
);

export const loadItemPerformanceDataSuccess = createAction(
  ItemDetailActionTypes.LOAD_PERFORMANCE_DATA_SUCCESS,
  (payload: PerformanceDataResponse) => ({payload})
);

export const loadItemPerformanceDataFailure = createAction(
  ItemDetailActionTypes.LOAD_PERFORMANCE_DATA_FAILURE,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (payload: any) => ({payload})
);